import React, { Dispatch } from "react";
import { flatten } from "lodash";

import {
  FilterAction,
  FilterReducerState,
  FilterSegmentContext,
} from "./useFilterReducer";

import MultiLogicFilter, {
  FilterSegmentProps,
} from "../../../MultiLogicFilter";

const FilterRows = ({
  filterState,
  dispatch,
}: {
  filterState: FilterReducerState;
  dispatch: Dispatch<FilterAction>;
}) => {
  const filterSegments = flatten(Object.values(filterState.filterValues)).map(
    filterValue => filterValue.filterSegment
  );

  const onFilterRemove = (
    _index: number,
    filterData: Array<FilterSegmentProps<FilterSegmentContext>>
  ) => {
    dispatch({ type: "removeFilter", data: { row: filterData } });
  };

  return (
    <div style={{ padding: "8px 0px" }}>
      <MultiLogicFilter
        filters={filterSegments}
        onFilterRemove={onFilterRemove}
        includeAndPrefix
      />
    </div>
  );
};

export default FilterRows;
